import { http } from '../http';
import { extrairMensagemErro } from '../../utils/apiError';

export interface ResultadoEntrega {
  /** `true` só quando a plataforma confirmou o envio. */
  enviado: boolean;
  /**
   * Link de entrega (com token). Vem também na falha, para o `wa.me` manual servir de
   * fallback — `null` só quando o backend não tem como montá-lo (falta `APP_PUBLIC_URL`).
   */
  link: string | null;
  mensagem: string;
  canal: 'OCTADESK' | 'MANUAL';
}

export interface ConfiguracaoEntrega {
  ativo: boolean;
  templateId: string;
  /** Se as credenciais existem no ambiente. Nunca devolve o valor delas. */
  credenciaisConfiguradas: boolean;
}

/**
 * Pede ao backend a entrega do contrato ao associado.
 *
 * ⚠️ Quem decide o canal é o backend: com o OctaDesk ligado, a mensagem sai pelo
 * template aprovado; caso contrário devolve o link para envio manual. A tela não
 * replica essa regra — só mostra o desfecho (convenção at-24/at-32).
 */
export const enviarContratoPorWhatsApp = async (
  contratoId: string,
): Promise<ResultadoEntrega> => {
  try {
    const { data } = await http.post(`/entrega-contrato/${contratoId}`);
    return data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao enviar o contrato ao associado'));
  }
};

export const buscarConfiguracaoEntrega = async (): Promise<ConfiguracaoEntrega> => {
  try {
    const { data } = await http.get('/entrega-contrato/configuracao');
    return data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao carregar a configuração de envio'));
  }
};

export const salvarConfiguracaoEntrega = async (payload: {
  ativo?: boolean;
  templateId?: string;
}): Promise<ConfiguracaoEntrega> => {
  try {
    const { data } = await http.put('/entrega-contrato/configuracao', payload);
    return data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao salvar a configuração de envio'));
  }
};
